<template>
	<div>
		<a-form-model ref="addForm"  :model="theObj" :rules="rules"  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
			<a-form-model-item label="集中器SIM" prop="gprsTel">
				<a-input  v-model="theObj.gprsTel"/>
			</a-form-model-item>
			<a-form-model-item label="集中器地址" prop="gprsAddr">
				<a-input  v-model="theObj.gprsAddr"/>
			</a-form-model-item>
			<a-form-model-item label="安装地址" prop="installAddr">
				<a-input  v-model="theObj.installAddr"/>
			</a-form-model-item>
			<a-form-model-item label="使用协议"  prop="gprsProtocol">
				<a-select style="width:20rem;" v-model="theObj.gprsProtocol" placeholder="请选择使用协议" >
					<a-select-option v-for="(item,index) in protocolList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="监听IP" prop="ip">
				<a-input  v-model="theObj.ip"/>
			</a-form-model-item>
			<a-form-model-item label="监听端口" prop="port">
				<a-input  v-model="theObj.port"/>
			</a-form-model-item>
			<a-form-model-item label="阀门清理">
				<a-switch   @change="changeSwitch" checked-children="开" un-checked-children="关"/>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-input  v-model="theObj.remark"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		props:[
			'neighborId',
		],
		data(){
			//加入这句，可以调用method里的方法
			let self = this;
			var gprsAddralidator = function(rule, value, callBack){
				if(value ==null ||value == ''){
					callback(new Error('请输入集中器地址'));
				}else{
					self.checkGprsExist(value,callBack);
				}
			};
			return{
				protocolList:this.Config.getProtocolList(),
				submitFlag:false,
				theObj:{
					gprsTel:null,
					gprsAddr:null,
					installAddr:null,
					gprsProtocol:undefined,
					ip:null,
					port:null,
					cleanSwitch:0,
					remark:null,
				},
				rules:{
					gprsTel:[{required:true,message:'请输入集中器SIM卡号',trigger: 'blur'}],
					gprsAddr:[
						{required:true,message:'请输入集中器地址',trigger: 'blur'},
						{validator: gprsAddralidator, trigger: 'blur' },
					],
					installAddr:[{required:true,message:'请输入集中器安装地址',trigger: 'blur'}],
					gprsProtocol:[{required:true,message:'请选择使用协议',trigger: 'change'}],
					ip:[{required:true,message:'请输入监听IP',trigger: 'blur'}],
					port:[{required:true,message:'请输入监听端口',trigger: 'blur'}],
				}, 
			}
		},
		methods:{
			checkGprsExist:function(addr,callback){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_GPRS_CHECK_EXIST_URL);
				let param = {gprsAddr:addr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					if(data.data.result ==1){
						callback(new Error('集中器已存在'));
					}else{
						callback();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
					this.$emit('refreshGprs');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_GPRS_ADD_URL);
				this.theObj.neighborId = this.neighborId;
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('添加集中器成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
			changeSwitch:function(checked,e){
				this.theObj.cleanSwitch = checked ? 1 : 0;
			}
		},
		
		
	}
</script>

<style>
</style>
